import React, { useState, useEffect } from "react";
import GoogleMapReact from "google-map-react";
import MarkerIcon from "../assets/images/icons/location-dark-icon.png";
import { useSelector } from "react-redux";

const AnyReactComponent = () => (
  <div>
    <img src={MarkerIcon.src} className="map-marker" alt="" />
  </div>
);

const MapComponent = () => {
  const [hostName, setHostName] = useState(null);
  const country = useSelector((state) => state.main.data?.country);
  const countryCode = String(country);
  const windowHost = async () => {
    const data = await window.location.hostname;
    setHostName(data);
  };
  useEffect(() => {
    windowHost();
  }, []);

  let latitude = 40.174932731219684;
  let longitude = 44.519321801261896;

  if (hostName === "handle.ge") {
    if (countryCode === "1") {
      latitude = 40.174932731219684;
      longitude = 44.519321801261896;
    } else if (countryCode === "2") {
      latitude = 45.02582561894678;
      longitude = 39.035091167621616;
    } else {
      latitude = 41.69389094863286;
      longitude = 44.872500243356185;
    }
  } else if (hostName === "handle.brand.ru") {
    if (countryCode === "1") {
      latitude = 40.174932731219684;
      longitude = 44.519321801261896;
    } else if (countryCode === "3") {
      latitude = 41.69389094863286;
      longitude = 44.872500243356185;
    } else {
      latitude = 45.02582561894678;
      longitude = 39.035091167621616;
    }
  } else {
    if (countryCode === "2") {
      latitude = 45.02582561894678;
      longitude = 39.035091167621616;
    } else if (countryCode === "3") {
      latitude = 41.69389094863286;
      longitude = 44.872500243356185;
    } else {
      latitude = 40.174932731219684;
      longitude = 44.519321801261896;
    }
  }

  const defaultProps = {
    center: {
      lat: latitude,
      lng: longitude,
    },
    zoom: 19,
  };
  //AIzaSyCIPP0mRcHez9CDT9MpcbL0hLKdh2jlhGY
  return (
    <GoogleMapReact
      bootstrapURLKeys={{ key: "AIzaSyCY-hvCJQJg1ZuvqGDklFdiUfl32dYsoJA" }}
      defaultCenter={defaultProps.center}
      defaultZoom={defaultProps.zoom}
    >
      <AnyReactComponent lat={latitude} lng={longitude} />
    </GoogleMapReact>
  );
};

export default MapComponent;
